export async function zipSearch() {
    const zipContainers = document.querySelectorAll(".zip-search-container");
    if(zipContainers){
        zipContainers.forEach( (e) =>{
            e.querySelector(".ocw-google-button").addEventListener( "click", ocwZipSearch );
            e.querySelector('input[name="ocw-google-zip"]').addEventListener( "keydown", ocwZipEnter );
        });
    }

    async function ocwZipSearch(e){
        e.preventDefault();
        const button = e.target;
        const zipMsg = button.parentNode.querySelector(".ocw-zip-message");
        zipMsg.style.display = "none";
        const searchTerm = button.parentNode.querySelector('input[name="ocw-google-zip"]');
        const zipLabel = button.parentNode.querySelector('label[for="ocw-google-zip"]');
        const labelText = (zipLabel) ? zipLabel.textContent :  "";
        const labelColor = (zipLabel) ? zipLabel.style.color : "";
        if(searchTerm.value.search(/^[0-9]{5}$/) > -1){
            searchTerm.classList.remove("error");
            searchTerm.removeAttribute("aria-invalid");
            zipLabel.classList.remove("error");
            zipLabel.textContent = labelText;
            zipLabel.style.color = labelColor;
            let searchLocation = await getZipLocation( searchTerm.value );
            if(searchLocation){
                window.open( 'https://' + location.hostname + '/locations/?search=' + searchTerm.value + '&store-service=all' );
            }else{
                zipMsg.style.display = "flex";
            }
        }else{
            searchTerm.classList.add("error");
            searchTerm.setAttribute("aria-invalid", "true");
            if(searchTerm.value == ""){
                zipLabel.textContent = (document.documentElement.lang === 'en-US') ? "Required" : "Requerido";
                
            }else{
                zipLabel.textContent = (document.documentElement.lang === 'en-US') ? "Invalid Zip" : "Código postal inválido";
                zipLabel.classList.add("error");
            }
            zipLabel.style.color = "#C63724";
        }
    }
        
    function ocwZipEnter(e){
        if (e.key === 'Enter') {
            e.target.parentNode.parentNode.querySelector(".ocw-google-button").click();
        }
    }

    async function getZipLocation( zipCode ){
        const zipUrl = new URL("/wp-json/ocwlocations/checkzip", window.location.origin);
        zipUrl.searchParams.set('zip', zipCode);
        const response = await fetch(zipUrl);

        if (!response.ok) {
        // non 200 response
        throw new Error(`Error ${response.status}: ${response.statusText}`);
        }

        let storesExist = await response.json();

        return storesExist;
    }
}